import get from 'transmute/get';
import getIn from 'transmute/getIn';
export const getDisablePrefill = get('disablePrefill');

/*  @ts-ignore Jun-18-2025, 19:10UTC fix types  */
export const getStagedPrefillEmail = state => getIn(['stagedFormState', 'email'], state) || '';

/*  @ts-ignore Jun-18-2025, 19:10UTC fix types  */
export const getInitialPrefillEmail = state => getIn(['initialFormState', 'email'], state) || '';